import KServiceStatusIcon from "./KServiceStatusIcon";
import {
	KDataTable,
	KDataTableMenu,
	KPhoneLink
} from "kinnect-general";
import {
	VIcon,
	VList,
	VListItem,
	VListItemAction,
	VListItemContent,
	VListItemTitle
} from "vuetify/lib";
import { formatDate, formatLocation } from "kinnect-formatters";

export default KDataTable.extend( {
	name: "KServicesTable",

	inject: [ "storeModuleName" ],

	props: {
		itemsPerPage: {
			...KDataTable.options.props.itemsPerPage,
			default: 5
		},

		noDataText: {
			...KDataTable.options.props.noDataText,
			default: "There are no services to display"
		},

		noResultsText: {
			...KDataTable.options.props.noResultsText,
			default: "No matching services found"
		},

		sortBy: {
			...KDataTable.options.props.sortBy,
			default: "serviceType.name"
		}
	},

	computed: {
		defaultHeaders() {
			return [
				{
					text: "Status",
					value: "serviceType.name"
				},
				{
					text: "Name",
					value: "name"
				},
				{
					text: "Address",
					value: "address"
				},
				{
					text: "Email",
					value: "email"
				},
				{
					text: "Phone",
					value: "phone"
				},
				{
					text: "Model",
					value: "model"
				},
				{
					text: "Model #",
					value: "modelNumber"
				},
				{
					text: "Serial #",
					value: "serialNumber"
				},
				{
					text: "Purchase Date",
					value: "purchaseDate"
				},
				{
					align: "end",
					sortable: false,
					text: this.isMobile ? "Actions" : "",
					value: "actions"
				}
			];
		},

		rootActiveMarker: {
			get() {
				return this.$store.state[this.storeModuleName].rootActiveMarker;
			},
			set( markerData ) {
				this.$store.dispatch( `${this.storeModuleName}/setRootActiveMarker`, markerData );
			}
		}
	},

	methods: {
		goToServiceMarker( idService ) {
			this.$emit( "goToMarker", idService );

			this.rootActiveMarker = {
				id: idService,
				type: "service"
			};
		}
	},

	render() {
		return <KDataTable
			attrs={this.$props}
			headers={this.$_headers}
			on={{ ...this.$listeners }}
			scopedSlots={{
				"item.serviceType.name": ( { item } ) =>
					<VListItem class="pa-0" dense>
						<VListItemAction class="mr-2">
							<KServiceStatusIcon
								color={item.serviceType.color}
							></KServiceStatusIcon>
						</VListItemAction>

						<VListItemContent>
							{item.serviceType.name}
						</VListItemContent>
					</VListItem>,

				"item.address": ( { item } ) => formatLocation( item ),

				"item.phone": ( { item } ) => (
					item.phone
						? <KPhoneLink class="text-no-wrap" phone={item.phone}></KPhoneLink>
						: "--"
				),

				"item.purchaseDate": ( { item } ) => formatDate( item.purchaseDate ),

				"item.actions": ( { item } ) =>
					<KDataTableMenu>
						<VList>
							<VListItem to={{
								name: "service",
								params: { idService: item.id }
							}}>
								<VListItemAction>
									<VIcon>visibility</VIcon>
								</VListItemAction>

								<VListItemContent>
									<VListItemTitle>View</VListItemTitle>
								</VListItemContent>
							</VListItem>

							{Boolean( this.storeModuleName ) && <VListItem
								onClick={() => this.goToServiceMarker( item.id )}
							>
								<VListItemAction>
									<VIcon>map</VIcon>
								</VListItemAction>

								<VListItemContent>
									<VListItemTitle>Go to on Map</VListItemTitle>
								</VListItemContent>
							</VListItem>}
						</VList>
					</KDataTableMenu>,

				...this.$scopedSlots
			}}
		></KDataTable>;
	}
} );
